import AkButton from '@atlaskit/button/standard-button';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { Component } from 'react';

import styles from './YellowButton.less';

export default class YellowButton extends Component {
  static propTypes = {
    className: PropTypes.string,
    href: PropTypes.string,
    onClick: PropTypes.func.isRequired,
    spacing: PropTypes.string,
    text: PropTypes.string.isRequired,
  };

  render() {
    return (
      <span className={styles.yellowButtonContainer}>
        <AkButton
          className={classNames(styles.yellowButton, this.props.className)}
          href={this.props.href}
          onClick={this.props.onClick}
          spacing={this.props.spacing}
        >
          {this.props.text}
        </AkButton>
      </span>
    );
  }
}
